<template>
	<div data-tour-scope="setting-api-payments">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title>
								{{ this.$vuetify.lang.t('$vuetify.front.subsetting.api_payments') }}
							</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>
							<v-spacer></v-spacer>
						</v-toolbar>


						<v-data-table
							:headers="headers"
							hide-default-footer
							disable-pagination
							disable-sort
							class="elevation-0 cellanowrap"
							:hide-default-header="isMobile || mobileCards"
							:class="{ mobile: isMobile, 'table-cards': mobileCards }"
							item-key="item._id"
							data-tour="table"
						>
							<template v-slot:body>
								<!-- telefono: ogni metodo di pagamento diventa una card, la configurazione si apre dentro la card -->
								<tbody v-if="mobileCards" class="apipay-cards">
									<tr v-for="s in servizi" :key="s.key">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card>
												<template v-slot:title>
													<span class="d-inline-flex align-center">
														<v-avatar size="24px" tile class="mr-2">
															<img :src="modello(s).setting.logo" :alt="s.nome" />
														</v-avatar>
														{{ s.nome }}
													</span>
												</template>
												<template v-slot:actions>
													<v-switch v-model="modello(s).active" @change="saveSetting(s.indice)" color="primary" class="mt-0 pt-0 mr-2" hide-details></v-switch>
													<v-btn small icon color="primary" :data-tour="s.indice === 0 ? 'expand' : null" :title="checkpresenza(s.indice) ? 'Chiudi' : 'Impostazioni'" @click="extension(s.indice)">
														<v-icon>{{ checkpresenza(s.indice) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
													</v-btn>
												</template>
												<template v-if="checkpresenza(s.indice)">
													<wallet-panel
														v-if="s.wallet"
														:modello="wallet"
														:editor="editor"
														:editor-config="editorConfig"
														:dropzone-options="dropzoneOptionsWalletImage"
														:get-image-flag="getImageFlag"
														:intestazione="false"
														@save="saveSetting(s.indice)"
														@normalize-amounts="normalizeWalletAmounts"
														@upload-complete="uploadCompleteWalletImage"
														@sending="sendingEvent"
														@remove-image="removeWalletImage"
														@drop="updateWalletImageDrop"
													/>
													<payment-panel
														v-else
														:servizio="s"
														:modello="modello(s)"
														:fees="fees"
														:options="options"
														:enablepaypal="enablepaypal"
														:translate="translateSetting"
														:get-image-flag="getImageFlag"
														:get-image-path="getImagePath"
														:intestazione="false"
														:data-tour="s.indice === 0 ? 'settings' : null"
														@save="saveSetting(s.indice)"
														@copy="copia(modello(s))"
														@translate="traduci(modello(s))"
														@toggle-option="toggleSelection($event, s.key)"
														@toggle-enabled="toggleSelectionEnabled($event, s.key)"
														@upload-pem="handleFileUpload"
														@check="openConnectionCheck"
													/>
												</template>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<template v-for="s in servizi">
										<tr :key="s.key" class="as-list-row" :class="{ 'as-list-row--open': checkpresenza(s.indice) }" @click="extension(s.indice)">
											<td class="pr-0" style="width: 40px">
												<v-btn small icon :data-tour="s.indice === 0 ? 'expand' : null" :title="checkpresenza(s.indice) ? 'Chiudi' : 'Impostazioni'" @click.stop="extension(s.indice)">
													<v-icon>{{ checkpresenza(s.indice) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
												</v-btn>
											</td>
											<td>
												<v-avatar size="32px" tile>
													<img :src="modello(s).setting.logo" :alt="s.nome" />
												</v-avatar>
												{{ s.nome }}
											</td>
											<td @click.stop>
												<v-switch v-model="modello(s).active" @change="saveSetting(s.indice)" color="primary" class="mt-0" hide-details></v-switch>
											</td>
										</tr>
										<tr v-if="checkpresenza(s.indice)" :key="s.key + '-panel'" class="as-expanded">
											<td :colspan="headers.length" class="py-3">
												<wallet-panel
													v-if="s.wallet"
													:modello="wallet"
													:editor="editor"
													:editor-config="editorConfig"
													:dropzone-options="dropzoneOptionsWalletImage"
													:get-image-flag="getImageFlag"
													@save="saveSetting(s.indice)"
													@normalize-amounts="normalizeWalletAmounts"
													@upload-complete="uploadCompleteWalletImage"
													@sending="sendingEvent"
													@remove-image="removeWalletImage"
													@drop="updateWalletImageDrop"
												/>
												<payment-panel
													v-else
													:servizio="s"
													:modello="modello(s)"
													:fees="fees"
													:options="options"
													:enablepaypal="enablepaypal"
													:translate="translateSetting"
													:get-image-flag="getImageFlag"
													:get-image-path="getImagePath"
													:data-tour="s.indice === 0 ? 'settings' : null"
													@save="saveSetting(s.indice)"
													@copy="copia(modello(s))"
													@translate="traduci(modello(s))"
													@toggle-option="toggleSelection($event, s.key)"
													@toggle-enabled="toggleSelectionEnabled($event, s.key)"
													@upload-pem="handleFileUpload"
													@check="openConnectionCheck"
												/>
											</td>
										</tr>
									</template>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Close</v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>
		<TourOverlay :tour="tour"></TourOverlay>
		<marketplace-connection-check v-model="connectionCheck.open" :service="connectionCheck.service"></marketplace-connection-check>
	</div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { uuid } from 'vue-uuid';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createApiPaymentsTourSteps, stopApiPaymentsTour } from './api-payments-tour';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import PaymentPanel from './components/PaymentPanel.vue';
import MarketplaceConnectionCheck from './components/MarketplaceConnectionCheck.vue';
import WalletPanel from './components/WalletPanel.vue';

Vue.use(CKEditor);
export default {
	name: 'ApiPayments',
	setup() {
		return { tour: useTour(createApiPaymentsTourSteps(), { onStop: stopApiPaymentsTour }) };
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
	},
	data() {
		return {
			options: [],
			enablepaypal: [],
			walletImageHeaders: [
				{ text: '', sortable: false },
				{ text: '#', sortable: false },
				{ text: 'Image', value: 'value', sortable: false },
				{ text: 'Azioni', sortable: false, align: 'right' },
			],

			items: [],
			fees: ['', 'Fisso', 'Percentuale'],
			setinterval: '',
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// riquadri aperti sotto le righe
			selected: [],
			// verifica connessione: verifica le impostazioni salvate
			connectionCheck: { open: false, service: 'paypal' },
			// righe fisse (i metodi di pagamento): niente paginazione ne' ordinamento
			headers: [
				{ text: '', sortable: false },
				{ text: 'Piattaforma', sortable: false },
				{ text: 'Status', sortable: false },
			],
			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,

			dialogconfirm: false,

			isActive: true,

			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},
			file: null,
			// righe della tabella: indice = argomento di saveSetting/extension, key = oggetto in data
			servizi: [
				{
					indice: 0,
					key: 'paypal',
					connessione: 'paypal',
					nome: 'Paypal',
					webhook: 'https://api.azseller.app/api/v1/nocors/payments/paypal',
					nota: 'Una volta confermato verrà restituito il <b>Webhook ID</b> da copiare e incollare nel campo <b>WebhookID</b>.',
					campi: [
						{ key: 'account', label: 'Account' },
						{ key: 'ClientID', label: 'Client ID' },
						{ key: 'Secret', label: 'Secret', tipo: 'password' },
						{ key: 'WebhookID', label: 'WebhookID' },
					],
				},
				{
					indice: 13,
					key: 'paypalcheckout',
					connessione: 'paypalcheckout',
					nome: 'Paypal Checkout',
					webhook: 'https://api.azseller.app/api/v1/nocors/payments/paypal',
					nota: 'Una volta confermato verrà restituito il <b>Webhook ID</b> da copiare e incollare nel campo <b>WebhookID</b>.',
					abilitati: true,
					campi: [
						{ key: 'account', label: 'Account' },
						{ key: 'ClientID', label: 'Client ID' },
						{ key: 'Secret', label: 'Secret', tipo: 'password' },
						{ key: 'WebhookID', label: 'WebhookID' },
					],
				},
				{
					indice: 1,
					key: 'stripe',
					connessione: 'stripe',
					nome: 'Stripe',
					webhook: 'https://api.azseller.app/api/v1/nocors/payments/stripe',
					campi: [
						{ key: 'ClientID', label: 'Client ID' },
						{ key: 'Secret', label: 'Secret', tipo: 'password' },
					],
				},
				{
					indice: 2,
					key: 'amazonpay',
					connessione: 'amazonpay',
					nome: 'Amazon Pay',
					pem: true,
					campi: [
						{ key: 'StoreID', label: 'StoreID' },
						{ key: 'SellerID', label: 'SellerID' },
						{ key: 'KeyPublicID', label: 'KeyPublicID' },
						{ key: 'ClientSecret', label: 'ClientSecret', tipo: 'password' },
						{ key: 'sandbox', label: 'Modalità sandbox', tipo: 'switch' },
					],
				},
				{
					indice: 3,
					key: 'googlepay',
					connessione: 'googlepay',
					nome: 'Google Pay',
					nota: 'Attenzione: Google Pay non è un metodo di pagamento ma un intermediario, il denaro passa da <b>Stripe</b>. Se Stripe non è attivo tra i metodi di pagamento, Google Pay non può essere attivato.',
					campi: [
						{ key: 'merchantId', label: 'MerchantId' },
						{ key: 'sandbox', label: 'Modalità sandbox', tipo: 'switch' },
					],
				},
				{ indice: 4, key: 'postepay', nome: 'Poste pay', campi: [] },
				{ indice: 5, key: 'banktransfer', nome: 'Bank transfer', campi: [] },
				{ indice: 6, key: 'cashdelivery', nome: 'Contrassegno', campi: [] },
				{ indice: 7, key: 'cash', nome: 'Pagamento in negozio', campi: [] },
				{
					indice: 8,
					key: 'scalapay',
					connessione: 'scalapay',
					nome: 'Scalapay',
					webhook: 'https://api.azseller.app/api/v1/nocors/payments/scalapay',
					campi: [
						{ key: 'Secret', label: 'Secret', tipo: 'password' },
						{ key: 'merchantToken', label: 'Merchant Token', tipo: 'password' },
					],
				},
				{
					indice: 9,
					key: 'nexi',
					connessione: 'nexi',
					nome: 'Nexi',
					campi: [
						{ key: 'Alias', label: 'Alias' },
						{ key: 'ChiaveMAC', label: 'Chiave MAC', tipo: 'password' },
						{ key: 'MerchantID', label: 'MerchantID' },
					],
				},
				{
					indice: 10,
					key: 'satispay',
					connessione: 'satispay',
					nome: 'Satispay',
					campi: [
						{ key: 'Token', label: 'Token', tipo: 'password' },
						{ key: 'key_id', label: 'Key ID' },
					],
				},
				{
					indice: 11,
					key: 'klarna',
					connessione: 'klarna',
					nome: 'Klarna',
					campi: [
						{ key: 'username', label: 'Username' },
						{ key: 'password', label: 'Password', tipo: 'password' },
						{ key: 'merchantID', label: 'MerchantID' },
					],
				},
				{
					indice: 12,
					key: 'crypto',
					connessione: 'crypto',
					nome: 'Crypto.com',
					campi: [
						{ key: 'Apikey', label: 'Apikey', tipo: 'password' },
						{ key: 'Secret', label: 'Secret', tipo: 'password' },
					],
				},
				{ indice: 14, key: 'wallet', nome: 'Wallet / Gift card', wallet: true, campi: [] },
			],
			translateSetting: false,
			walletLangTab: 0,
			isMobile: false,
			editor: ClassicEditor,
			editorConfig: {
				ckfinder: {
					uploadUrl: '',
				},
			},
			dropzoneOptionsWalletImage: {
				url: '',
				thumbnailWidth: 150,
				maxFilesize: 20,
				acceptedFiles: '.jpg,.jpeg,.png,.gif,.webp,.svg',
				headers: '',
				method: 'post',
			},
			paypal: {
				active: '',
				setting: {
					account: '',
					ClientID: '',
					Secret: '',
					typefee: '',
					fee: '',
					WebhookID: '',
					trans: [],
					logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/paypal.svg`,
					options: [],
				},
				service: 'paypal',
				type: 'apiPayments',
			},
			paypalcheckout: {
				active: '',
				setting: {
					account: '',
					ClientID: '',
					Secret: '',
					typefee: '',
					fee: '',
					WebhookID: '',
					trans: [],
					logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/paypal.svg`,
					options: [],
					enabled: [],
				},
				service: 'paypalcheckout',
				type: 'apiPayments',
			},
			crypto: {
				active: '',
				setting: {
					Apikey: '',
					Secret: '',
					typefee: '',
					fee: '',
					trans: [],
					logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/crypto.svg`,
					options: [],
				},
				service: 'crypto',
				type: 'apiPayments',
			},
			scalapay: {
				active: false,
				setting: {
					Secret: '',
					merchantToken: '',
					typefee: '',
					fee: '',
					trans: [],
					logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/scalapay.svg`,
					options: [],
				},

				service: 'scalapay',
				type: 'apiPayments',
			},
			klarna: {
				active: false,
				setting: {
					username: '',
					password: '',
					merchantID: '',
					typefee: '',
					fee: '',
					trans: [],
					logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/klarna.svg`,
					options: [],
				},

				service: 'klarna',
				type: 'apiPayments',
			},
			satispay: {
				active: false,
				setting: {
					Token: '',
					typefee: '',
					fee: '',
					trans: [],
					logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/satisplay.svg`,
					options: [],
					key_id: '',
				},

				service: 'satispay',
				type: 'apiPayments',
			},
			nexi: {
				active: false,
				setting: {
					ChiaveMAC: '',
					Alias: '',
					MerchantID: '',
					typefee: '',
					fee: '',
					trans: [],
					logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/nexi.svg`,
					options: [],
				},

				service: 'nexi',
				type: 'apiPayments',
			},
			stripe: {
				active: false,
				setting: {
					ClientID: '',
					Secret: '',
					typefee: '',
					fee: '',
					trans: [],
					logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/stripe.svg`,
					options: [],
				},
				service: 'stripe',
				type: 'apiPayments',
			},
			amazonpay: {
				active: false,
				setting: {
					typefee: '',
					fee: '',
					trans: [],
					StoreID: '',
					SellerID: '',
					KeyPublicID: '',
					ClientSecret: '',
					pem: '',
					logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/amazonpay.svg`,
					options: [],
					sandbox: false,
				},

				service: 'amazonpay',
				type: 'apiPayments',
			},
			googlepay: {
				active: false,
				setting: {
					typefee: '',
					fee: '',
					trans: [],
					logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/googlepay.svg`,
					options: [],
					merchantId: '',
					sandbox: false,
				},

				service: 'googlepay',
				type: 'apiPayments',
			},
			postepay: {
				active: false,
				setting: {
					typefee: '',
					fee: '',
					trans: [],
					logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/postepay.svg`,
					options: [],
				},

				service: 'postepay',
				type: 'apiPayments',
			},
			banktransfer: {
				active: false,
				setting: {
					typefee: '',
					fee: '',
					trans: [],
					logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/bank.svg`,
					options: [],
				},

				service: 'banktransfer',
				type: 'apiPayments',
			},
			cashdelivery: {
				active: false,
				setting: {
					typefee: '',
					fee: '',
					trans: [],
					logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/cashdelivery.svg`,
					options: [],
				},

				service: 'cashdelivery',
				type: 'apiPayments',
			},
			cash: {
				active: false,
				setting: {
					typefee: '',
					fee: '',
					trans: [],
					logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/payshop.svg`,
					options: [],
				},

				service: 'cash',
				type: 'apiPayments',
			},
			wallet: {
				active: false,
				setting: {
					name: {
						trans: [],
					},
					text: {
						trans: [],
					},
					amounts: [],
					images: [],
					logo: require('@/assets/images/iconpay/wallet.svg'),
				},
				service: 'wallet',
				type: 'apiPayments',
			},
		};
	},
	filters: {
		fixed: function (value) {
			if (!+value) return '';
			return _.round(value, 2);
		},
	},
	async mounted() {
		this.setPreload(true);
		let promises = [];
		promises.push(this.fetchSettings());

		const listsPayments = [
			'googletranslate',
			'paypal',
			'paypalcheckout',
			'stripe',
			'cashdelivery',
			'banktransfer',
			'cash',
			'postepay',
			'googlepay',
			'amazonpay',
			'scalapay',
			'nexi',
			'klarna',
			'satispay',
			'crypto',
			'wallet',
		];
		this.options = [
			{ logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/paypal.svg`, name: 'Paypal' },
			{ logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/paypal.svg`, name: 'Paypal Checkout' },
			{ logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/amazonpay.svg`, name: 'Amazon pay' },
			{ logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/applepay.svg`, name: 'Apple pay' },
			{ logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/bitcoin.svg`, name: 'Bitcoin' },
			{ logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/cirrus.svg`, name: 'Cirrus' },
			{ logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/googlepay.svg`, name: 'Google pay' },
			{ logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/jcb.svg`, name: 'JCB' },
			{ logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/klarna.svg`, name: 'Klarna' },
			{ logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/mastercard.svg`, name: 'Mastercard' },
			{ logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/nexi.svg`, name: 'Nexi' },
			{ logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/satisplay.svg`, name: 'Satispay' },
			{ logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/scalapay.svg`, name: 'Scalapay' },
			{ logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/stripe.svg`, name: 'Stripe' },
			{ logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/unionpay.svg`, name: 'Unionpay' },
			{ logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/visa.svg`, name: 'Visa' },
			{ logo: `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/maestro.svg`, name: 'Maestro' },
			{ logo: require('@/assets/images/iconpay/wallet.svg'), name: 'Wallet' },
		];
		this.enablepaypal = [
			{ logo: `@/assets/images/payments/Paypal.svg`, name: 'paylater' },
			{ logo: `@/assets/images/payments/paypalcheckout/venmo-svgrepo-com.svg`, name: 'venmo' },
			{ logo: `@/assets/images/payments/paypalcheckout/code-svgrepo-com.svg`, name: 'card' },
			{ logo: `@/assets/images/payments/paypalcheckout/code-svgrepo-com.svg`, name: 'credit' },
			{ logo: `@/assets/images/payments/paypalcheckout/Single_Euro_Payments_Area_logo.svg`, name: 'sepa' },
			{ logo: `@/assets/images/payments/paypalcheckout/paypal_bancontact_color.svg`, name: 'bancontact' },
			{ logo: `@/assets/images/payments/paypalcheckout/paypal_blik_color.svg`, name: 'blik' },
			{ logo: `@/assets/images/payments/paypalcheckout/paypal_eps_color.svg`, name: 'eps' },
			{ logo: `@/assets/images/payments/paypalcheckout/paypal_giropay_color.svg`, name: 'giropay' },
			{ logo: `@/assets/images/payments/paypalcheckout/paypal_ideal_color.svg`, name: 'ideal' },
			{ logo: `@/assets/images/payments/paypalcheckout/paypal_mybank_color.svg`, name: 'mybank' },
			{ logo: `@/assets/images/payments/paypalcheckout/paypal_przelewy24_color.svg`, name: 'p24' },
			{ logo: `@/assets/images/payments/paypalcheckout/paypal_sofort_black.svg`, name: 'sofort' },
		];
		promises.push(this.fetchService(listsPayments));
		const results = await Promise.all(promises);
		const settings = results[0];
		this.editorConfig.ckfinder.uploadUrl = `${this.getUrl}multimedias/ckeditor?token=${this.getToken}`;
		this.dropzoneOptionsWalletImage.url = `${this.getUrl}multimedias/uploadimage`;
		this.dropzoneOptionsWalletImage.headers = { Authorization: `Bearer ${this.getToken}` };

		const langDefault = settings.languages.find(el => el.default === true).lang; //.find({ default: true }).lang;

		settings.languages.sort((a, b) => {
			return (b.default === true) - (a.default === true);
		});

		settings.languages = settings.languages.filter(el => el.is_active === true);
		const transLanguageEmpty = [];
		for (const lang of settings.languages) {
			transLanguageEmpty.push({
				lang: lang.lang,
				text: '',
			});
		}
		let translate = _.find(this.getServices, { service: 'googletranslate' });
		if (translate) {
			this.translateSetting = translate.active;
		}
		/*for (let list of listsPayments) {
			if (this[list] && this[list]?.setting && this[list]?.setting?.trans) {
				for (let trans of transLanguageEmpty) {
					const findLanguage = this[list].setting.trans.find(el => el.lang === trans.lang);
					if (!findLanguage) {
						this[list].setting.trans.push(trans);
					}
				}
			}
		}
		console.log(this.paypal.setting.trans);*/
		//this.lang = this.getSettings.languages.find({ default: true }).lang;
		//this.units = result.unit
		//this.getSettings.languages = _.orderBy(this.getSettings.languages, ['default'], ['desc']);
		//this.languages = _.filter(this.getSettings.languages, { is_active: true });

		this.setPreload(false);

		const paypal = _.find(this.getServices, set => {
			return set.service === 'paypal';
		});
		if (paypal) {
			this.paypal = paypal;
			this.paypal.setting.logo = `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/paypal.svg`;
			this.paypal.setting.options = !this.paypal.setting.options ? [] : this.paypal.setting.options;
		}
		if (this.paypal) {
			await this.createTrans(this.paypal, transLanguageEmpty);
		}
		const paypalcheckout = _.find(this.getServices, set => {
			return set.service === 'paypalcheckout';
		});
		if (paypalcheckout) {
			this.paypalcheckout = paypalcheckout;
			this.paypalcheckout.setting.logo = `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/paypal.svg`;
			this.paypalcheckout.setting.options = !this.paypalcheckout.setting.options ? [] : this.paypalcheckout.setting.options;
			this.paypalcheckout.setting.enabled = !this.paypalcheckout.setting.enabled ? [] : this.paypalcheckout.setting.enabled;
		}
		if (this.paypalcheckout) {
			await this.createTrans(this.paypalcheckout, transLanguageEmpty);
		}

		const crypto = _.find(this.getServices, set => {
			return set.service === 'crypto';
		});
		if (crypto) {
			this.crypto = crypto;
			this.crypto.setting.logo = `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/crypto.svg`;
			this.crypto.setting.options = !this.crypto.setting.options ? [] : this.crypto.setting.options;
		}
		if (this.crypto) {
			await this.createTrans(this.crypto, transLanguageEmpty);
		}

		const stripe = _.find(this.getServices, set => {
			return set.service === 'stripe';
		});
		if (stripe) {
			this.stripe = stripe;
			this.stripe.setting.logo = `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/stripe.svg`;
			this.stripe.setting.options = !this.stripe.setting.options ? [] : this.stripe.setting.options;
		}
		if (this.stripe) {
			await this.createTrans(this.stripe, transLanguageEmpty);
		}

		const cashdelivery = _.find(this.getServices, set => {
			return set.service === 'cashdelivery';
		});
		if (cashdelivery) {
			this.cashdelivery = cashdelivery;
			this.cashdelivery.setting.logo = `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/cashdelivery.svg`;
			this.cashdelivery.setting.options = !this.cashdelivery.setting.options ? [] : this.cashdelivery.setting.options;
		}
		if (this.cashdelivery) {
			await this.createTrans(this.cashdelivery, transLanguageEmpty);
		}

		const banktransfer = _.find(this.getServices, set => {
			return set.service === 'banktransfer';
		});
		if (banktransfer) {
			this.banktransfer = banktransfer;
			this.banktransfer.setting.logo = `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/bank.svg`;
			this.banktransfer.setting.options = !this.banktransfer.setting.options ? [] : this.banktransfer.setting.options;
		}
		if (this.banktransfer) {
			await this.createTrans(this.banktransfer, transLanguageEmpty);
		}

		const cash = _.find(this.getServices, set => {
			return set.service === 'cash';
		});
		if (cash) {
			this.cash = cash;
			this.cash.setting.logo = `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/payshop.svg`;
			this.cash.setting.options = !this.cash.setting.options ? [] : this.cash.setting.options;
			// il campo "Valore fee" scriveva per errore in setting.Secret, mentre il carrello legge setting.fee:
			// il valore vecchio si riporta nel campo giusto e diventa effettivo al prossimo Conferma
			if ((this.cash.setting.fee === undefined || this.cash.setting.fee === '') && this.cash.setting.Secret) {
				this.$set(this.cash.setting, 'fee', this.cash.setting.Secret);
			}
		}
		if (this.cash) {
			await this.createTrans(this.cash, transLanguageEmpty);
		}

		const postepay = _.find(this.getServices, set => {
			return set.service === 'postepay';
		});
		if (postepay) {
			this.postepay = postepay;
			this.postepay.setting.logo = `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/postepay.svg`;
			this.postepay.setting.options = !this.postepay.setting.options ? [] : this.postepay.setting.options;
		}
		if (this.postepay) {
			await this.createTrans(this.postepay, transLanguageEmpty);
		}

		const googlepay = _.find(this.getServices, set => {
			return set.service === 'googlepay';
		});
		if (googlepay) {
			this.googlepay = googlepay;
			this.googlepay.setting.logo = `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/googlepay.svg`;
			this.googlepay.setting.options = !this.googlepay.setting.options ? [] : this.googlepay.setting.options;
		}
		if (this.googlepay) {
			await this.createTrans(this.googlepay, transLanguageEmpty);
		}

		const amazonpay = _.find(this.getServices, set => {
			return set.service === 'amazonpay';
		});
		if (amazonpay) {
			this.amazonpay = amazonpay;
			this.amazonpay.setting.logo = `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/amazonpay.svg`;
			this.amazonpay.setting.options = !this.amazonpay.setting.options ? [] : this.amazonpay.setting.options;
		}
		if (this.amazonpay) {
			await this.createTrans(this.amazonpay, transLanguageEmpty);
		}

		const scalapay = _.find(this.getServices, set => {
			return set.service === 'scalapay';
		});
		if (scalapay) {
			this.scalapay = scalapay;
			this.scalapay.setting.logo = `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/scalapay.svg`;
			this.scalapay.setting.options = !this.scalapay.setting.options ? [] : this.scalapay.setting.options;
		}
		if (this.scalapay) {
			await this.createTrans(this.scalapay, transLanguageEmpty);
		}

		const nexi = _.find(this.getServices, set => {
			return set.service === 'nexi';
		});
		if (nexi) {
			this.nexi = nexi;
			this.nexi.setting.logo = `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/nexi.svg`;
			this.nexi.setting.options = !this.nexi.setting.options ? [] : this.nexi.setting.options;
		}
		if (this.nexi) {
			await this.createTrans(this.nexi, transLanguageEmpty);
		}

		const klarna = _.find(this.getServices, set => {
			return set.service === 'klarna';
		});
		if (klarna) {
			this.klarna = klarna;
			this.klarna.setting.logo = `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/klarna.svg`;
			this.klarna.setting.options = !this.klarna.setting.options ? [] : this.klarna.setting.options;
		}
		if (this.klarna) {
			await this.createTrans(this.klarna, transLanguageEmpty);
		}

		const satispay = _.find(this.getServices, set => {
			return set.service === 'satispay';
		});
		if (satispay) {
			this.satispay = satispay;
			this.satispay.setting.logo = `${process.env.VUE_APP_AWS_CLOUDFRONT}/payments/satisplay.svg`;
			this.satispay.setting.options = !this.satispay.setting.options ? [] : this.satispay.setting.options;
		}
		if (this.satispay) {
			await this.createTrans(this.satispay, transLanguageEmpty);
		}

		const wallet = _.find(this.getServices, set => {
			return set.service === 'wallet';
		});
		if (wallet) {
			this.wallet = wallet;
			if (!this.wallet.setting) {
				this.wallet.setting = {};
			}
			this.wallet.setting.logo = require('@/assets/images/iconpay/wallet.svg');
			this.wallet.setting.amounts = !this.wallet.setting.amounts ? [] : this.wallet.setting.amounts;
			this.wallet.setting.images = !this.wallet.setting.images ? [] : this.wallet.setting.images;
		}
		if (this.wallet) {
			await this.createWalletTrans(this.wallet, settings.languages);
			this.normalizeWalletAmounts();
		}
	},

	components: {
		TourOverlay,
		KeyValueCard,
		PaymentPanel,
		WalletPanel,
		MarketplaceConnectionCheck,
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getId: 'profile/getId',
			getUrl: 'settings/getUrl',

			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getSettings: 'settings/getSetting',
			getDrawerFilter: 'settings/getDrawerFilter',

			getServices: 'services/getServices',
		}),
	},

	methods: {
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',
			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchSettings: 'settings/asyncFetchData',
			fetchService: 'services/getServiceFetch',

			destroyData: 'settings/destroyData',
			setSettings: 'settings/updateData',
			setService: 'services/updateData',
		}),
		toggleSelection(item, property) {
			if (!this[property]?.setting?.options) {
				this[property].setting.options = [];
			}
			const index = this[property].setting.options.findIndex(option => option.name === item.name);

			if (index === -1) {
				// Se non è presente, aggiungilo
				this[property].setting.options.push(item);
			} else {
				// Se è presente, rimuovilo
				this[property].setting.options.splice(index, 1);
			}
		},
		toggleSelectionEnabled(item, property) {
			if (!this[property]?.setting?.enabled) {
				this[property].setting.enabled = [];
			}
			const index = this[property].setting.enabled.findIndex(option => option.name === item.name);

			if (index === -1) {
				// Se non è presente, aggiungilo
				this[property].setting.enabled.push(item);
			} else {
				// Se è presente, rimuovilo
				this[property].setting.enabled.splice(index, 1);
			}
		},
		async handleFileUpload(file) {
			if (file && file.name) {
				const formData = new FormData();
				formData.append('file', file, file.name);
				formData.append('uuid', uuid.v4());

				const response = await axios.post(`${this.getUrl}multimedias/uploadfile`, formData, {
					headers: {
						'Content-Type': 'multipart/form-data', // Imposta il tipo di contenuto
						Authorization: `Bearer ${this.getToken}`,
					},
				});

				this.amazonpay.setting.pem = response.data.url;
				this.$forceUpdate();
				//payload.value['sitemaps'].push(image);
			}
			/*if (this.amazonpay.setting?.pem) {
				console.log('File caricato:', this.amazonpay.setting.pem);
			}*/
		},
		onResize() {
			this.isMobile = window.innerWidth < 769;
		},
		async createTrans(method, transLanguageEmpty) {
			if (!method.setting?.trans) {
				Object.assign(method.setting, { trans: [] });
			}

			for (let trans of transLanguageEmpty) {
				const findLanguage = method.setting.trans.find(el => el.lang === trans.lang);
				if (!findLanguage) {
					method.setting.trans.push(trans);
				}
			}
		},
		async createWalletTrans(method, languages) {
			if (!method.setting) {
				Object.assign(method, { setting: {} });
			}
			if (!method.setting?.name) {
				Object.assign(method.setting, { name: { trans: [] } });
			}
			if (!method.setting?.name?.trans) {
				Object.assign(method.setting.name, { trans: [] });
			}
			if (!method.setting?.text) {
				Object.assign(method.setting, { text: { trans: [] } });
			}
			if (!method.setting?.text?.trans) {
				Object.assign(method.setting.text, { trans: [] });
			}

			for (let lang of languages) {
				const findName = method.setting.name.trans.find(el => el.lang === lang.lang);
				if (!findName) {
					method.setting.name.trans.push({ lang: lang.lang, name: '' });
				}

				const findText = method.setting.text.trans.find(el => el.lang === lang.lang);
				if (!findText) {
					method.setting.text.trans.push({ lang: lang.lang, text: '' });
				} else {
					findText.text = _.unescape(findText.text);
				}
			}

			method.setting.name.trans = _.orderBy(method.setting.name.trans, item => {
				const language = languages.find(lang => lang.lang === item.lang);
				return language ? languages.indexOf(language) : languages.length;
			});
			method.setting.text.trans = _.orderBy(method.setting.text.trans, item => {
				const language = languages.find(lang => lang.lang === item.lang);
				return language ? languages.indexOf(language) : languages.length;
			});
		},
		normalizeWalletAmounts() {
			this.wallet.setting.amounts = _.uniq(this.wallet.setting.amounts.map(amount => parseFloat(_.toString(amount).replace(',', '.'))).filter(amount => !Number.isNaN(amount) && amount > 0));
		},
		sendingEvent(file, xhr, formData) {
			formData.append('uuid', uuid.v4());
		},
		uploadCompleteWalletImage(file) {
			if (file.xhr) {
				const response = JSON.parse(file.xhr.response);
				this.wallet.setting.images.push({ value: response.url, size: file.size });
				this.$forceUpdate();
			}
		},
		removeWalletImage(index) {
			this.wallet.setting.images.splice(index, 1);
		},
		updateWalletImageDrop(dropResult) {
			if (dropResult.moved) {
				const oldValue = this.wallet.setting.images[dropResult.moved.oldIndex];
				this.wallet.setting.images.splice(dropResult.moved.oldIndex, 1);
				this.wallet.setting.images.splice(dropResult.moved.newIndex, 0, oldValue);
			}
		},
		getImageFlag(img) {
			try {
				return require(`@/assets/images/flag/${_.upperCase(img)}.svg`);
			} catch (e) {
				return require('@/assets/images/flag/map.svg');
			}
		},
		getImagePath(logo) {
			try {
				let response = null;
				switch (logo) {
					case 'sofort': {
						response = require(`@/assets/images/payments/paypalcheckout/paypal_sofort_black.svg`);
						break;
					}
					case 'p24': {
						response = require(`@/assets/images/payments/paypalcheckout/paypal_przelewy24_color.svg`);
						break;
					}
					case 'mybank': {
						response = require(`@/assets/images/payments/paypalcheckout/paypal_mybank_color.svg`);
						break;
					}
					case 'ideal': {
						response = require(`@/assets/images/payments/paypalcheckout/paypal_ideal_color.svg`);
						break;
					}
					case 'giropay': {
						response = require(`@/assets/images/payments/paypalcheckout/paypal_giropay_color.svg`);
						break;
					}
					case 'eps': {
						response = require(`@/assets/images/payments/paypalcheckout/paypal_eps_color.svg`);
						break;
					}
					case 'paylater': {
						response = require(`@/assets/images/payments/paypalcheckout/paypalcheckout.svg`);
						break;
					}
					case 'venmo': {
						response = require(`@/assets/images/payments/paypalcheckout/venmo-svgrepo-com.svg`);
						break;
					}
					case 'card': {
						response = require(`@/assets/images/payments/paypalcheckout/code-svgrepo-com.svg`);
						break;
					}
					case 'credit': {
						response = require(`@/assets/images/payments/paypalcheckout/code-svgrepo-com.svg`);
						break;
					}
					case 'sepa': {
						response = require(`@/assets/images/payments/paypalcheckout/Single_Euro_Payments_Area_logo.svg`);
						break;
					}
					case 'bancontact': {
						response = require(`@/assets/images/payments/paypalcheckout/paypal_bancontact_color.svg`);
						break;
					}
					case 'blik': {
						response = require(`@/assets/images/payments/paypalcheckout/paypal_blik_color.svg`);
						break;
					}
				}
				return response;
			} catch (e) {
				console.error('Immagine non trovata:', logo);
				return null; // O un'immagine di fallback
			}
		},
		copia(item) {
			const master = item.setting.trans[0].text;

			for (let trans of item.setting.trans) {
				//Object.assign(trans, { text: master });

				trans.text = master;
				//trans.text = master;
			}
			this.$nextTick(() => {
				this.$forceUpdate();
			});
		},
		async traduci(item) {
			for (let tran of item.setting.trans) {
				if (tran.text !== '') {
					let datapost = {
						target: tran.lang,
						words: {
							text: tran.text,
						},
					};
					const res = await axios.post(`${this.getUrl}translates`, { data: datapost }, { headers: { Authorization: `Bearer ${this.getToken}` } });

					tran.text = res.data.data[0];
					this.$nextTick(() => {
						this.$forceUpdate();
					});
				}
			}
		},
		saveSetting(item) {
			let payload;
			switch (item) {
				case 0:
					payload = this.paypal;
					this.setPreload(true);
					break;
				case 13:
					payload = this.paypalcheckout;
					this.setPreload(true);
					break;
				case 1:
					payload = this.stripe;
					this.setPreload(true);
					break;
				case 2:
					payload = this.amazonpay;
					this.setPreload(true);
					break;
				case 3:
					payload = this.googlepay;
					this.setPreload(true);
					break;
				case 4:
					payload = this.postepay;
					this.setPreload(true);
					break;
				case 5:
					payload = this.banktransfer;
					this.setPreload(true);
					break;
				case 6:
					payload = this.cashdelivery;
					this.setPreload(true);
					break;
				case 7:
					payload = this.cash;
					this.setPreload(true);
					break;
				case 8:
					payload = this.scalapay;
					this.setPreload(true);
					break;
				case 9:
					payload = this.nexi;
					this.setPreload(true);
					break;
				case 10:
					payload = this.satispay;
					this.setPreload(true);
					break;
				case 11:
					payload = this.klarna;
					this.setPreload(true);
					break;
				case 12:
					payload = this.crypto;
					this.setPreload(true);
					break;
				case 14:
					this.normalizeWalletAmounts();
					payload = this.wallet;
					this.setPreload(true);
					break;
			}
			let url = 'services/update';
			axios
				.post(`${this.getUrl}${url}`, payload, {
					headers: { Authorization: `Bearer ${this.getToken}` },
				})
				.then(({ data }) => {
					//this.setService(data.data);
					this.setPreload(false);
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.setPreload(false);
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		extension(item) {
			let check = this.selected.includes(item);
			if (!check) {
				this.selected.push(item);
			} else {
				let index = this.selected.indexOf(item);
				this.selected.splice(index, 1);
			}
		},
		checkpresenza(item) {
			return this.selected.includes(item);
		},
		// oggetto in data del metodo (paypal, stripe, ...): created() lo sostituisce, quindi va letto ogni volta
		openConnectionCheck(service) {
			this.connectionCheck.service = service;
			this.connectionCheck.open = true;
		},
		modello(servizio) {
			return this[servizio.key];
		},
	},
};
</script>

<style scoped>
/* lista compatta: la riga aperta si colora e sotto compare il riquadro di configurazione */
.as-list-row {
	cursor: pointer;
}
.as-list-row--open,
.as-list-row--open:hover {
	background: #f3f6fa !important;
}
.as-expanded,
.as-expanded:hover {
	background: transparent !important;
}
.wallet-tabs-items,
.wallet-tabs-items.theme--light {
	background-color: transparent !important;
}

.wallet-tabs-items ::v-deep .v-window__container,
.wallet-tabs-items ::v-deep .v-window-item,
.wallet-tabs-items ::v-deep .v-tab-item {
	background-color: transparent !important;
}

.wallet-field-label {
	font-weight: 600;
	margin-bottom: 6px;
}

/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.apipay-cards,
.apipay-cards tr {
	display: block;
	width: 100%;
}
.apipay-cards tr,
.apipay-cards tr:hover {
	background: transparent !important;
}
.apipay-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.apipay-cards tr:first-child td {
	padding-top: 12px !important;
}
.apipay-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.apipay-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
/* card in lista fuori da v-data-table */
.kv-list > .kv-card + .kv-card {
	margin-top: 8px;
}
</style>
